import React from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import './App.css';
import background_paint from "./pages/Background_paint";
import other_works from "./pages/other_works";
import personal from "./pages/Personal";
import About from "./pages/About";
import Background_Layout from "./pages/Background_layout";
import MoongirlLayout from "./pages/MoongirlLayout"; // 新建MoonGirl页面
import LegoLayout from "./pages/LegoLayout"; // 新建LEGO页面
import JumperLayout from "./pages/JumperLayout"; // 新建Jumper页面

// 路由配置（示例，按你现有结构改）


function App() {
  return (
      <div className={"App"}>
            <Router >
                <div>
                    <Route path="/" component={personal} exact/>
                    <Route path='/works/background_paint' component={background_paint} />
                    <Route path='/works/other_works' component={other_works}/>
                    <Route path='/works/personal' component={personal}/>
                    <Route path="/about" component={About}/>
                    <Route path="/works/background_layout" component={Background_Layout}/>
                    <Route path="/works/moongirl" element={<MoongirlLayout />} />
                    <Route path="/works/lego" element={<LegoLayout />} />
                    <Route path="/works/jumper" element={<JumperLayout />} />
                </div>
            </Router>

      </div>
  );
}

export default App;
